import { createSlice } from "@reduxjs/toolkit";
import { ApiStatus } from "../../types/api/status";
import { Permission, PermissionByUserType, PermissionUser, permissionType } from "../../types/slices/permissionType";
import { RootState } from "../store";

const initialState:permissionType =
{
    status: ApiStatus.FETCHED,
    permissionsByUserType: [],
    permissions: [],
    permissionsUser: [],
    errorMessage: undefined
}

const permissionSlice = createSlice({
    name: 'permissionSlice',
    initialState,
    reducers: {
        onFetchPermissionsByUserType (state, { payload }: { payload: PermissionByUserType[]}) {
            state.status = ApiStatus.FETCHED
            state.permissionsByUserType = payload
            state.errorMessage = undefined
        },
        onFetchPermission (state, { payload }: { payload: Permission[]}) {
            state.status = ApiStatus.FETCHED
            state.permissions = payload
            state.errorMessage = undefined
        },
        onFetchPermissionUser (state, { payload }: { payload: PermissionUser[]}) {
            state.status = ApiStatus.FETCHED
            state.permissionsUser = payload
            state.errorMessage = undefined
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        }
    }
})

export const selectPermissionState = (state: RootState) => state.permissionSlice
export default permissionSlice.reducer

export const {
    onFetchPermissionsByUserType,
    onFetchPermission,
    changeStatus,
    onFetchPermissionUser
} = permissionSlice.actions